import React, { useEffect, useState } from "react";
import ViewOtherIncomePage from "../../../../../entities/DashboardPage/AccountingModule/OtherIncome/ViewOtherIncome";
import LoaderHelper from "../../../../../utils/Loader/LoaderHelper";
import AuthService from "../../../../../api/AuthService";
import { useLocation, useNavigate } from "react-router-dom";
import { useAlert } from "../../../../../context/AlertContext";


const ViewOtherIncome = () => {
  const [banks, setBanks] = useState();
  const [types, setTypes] = useState()
  const location = useLocation()
  const {item} = location?.state || {}
  const {showAlert} = useAlert()
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
    
  useEffect(() => {
    getAllBanks()
    getExpenseType("Income")
  },[])
  const getAllBanks = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getAllBanks();
      if (result?.success) {
        setBanks(result?.data?.bankAccounts);
        LoaderHelper.loaderStatus(false);
      } else { 
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const getExpenseType = async (type) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getExpenseType(type);
      if (result?.success) {
        setTypes(result?.data?.types);
        LoaderHelper.loaderStatus(false);
      } else { 
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const updateOtherIncome = async (id,data,type,date,paymentMode,bankDetails,files) => {
    setLoading(true);
    try {
      const result = await AuthService.updateOtherIncome(id,data,type,date,paymentMode,bankDetails,files);
      if (result?.success === true) {
        setLoading(false);
        showAlert(result?.message, "success");
        navigate("/dashboard/otherIncome")
      } else {
        setLoading(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false);
      showAlert(error, "error");
    }
  };
  return(
    <>
      <ViewOtherIncomePage loading={loading} updateOtherIncome={updateOtherIncome} types={types} item={item} banks={banks}/>
    </>
  )
}

export default ViewOtherIncome